import React, { useEffect, useState, cloneElement } from 'react';
import { connect } from "react-redux";
import produce from "immer";
import classnames from "classnames";


const Translated = ({ languages, translations, children, onChanged, enabled = true }) => {

    if (!enabled) {
        return children;
    }

    const [selected, setSelected] = useState(null);
    const field = children.props.name;

    const onChange = (e, lang) => {

        const newTranslation = produce(translations, (draft) => {
            draft[field] = draft[field] || {};
            draft[field][lang.id] = e.target.value;
        });

        onChanged(newTranslation);
    };

    if (Array.isArray(translations)) {
        translations = {};
    }

    const fieldTranslations = translations ? translations[field] || {} : {};

    const getFormInput = (selected) => {
        return cloneElement(children, {
            name: "translation_" + field + '_' + selected.id,
            onChange: (e) => onChange(e, selected),
            value: fieldTranslations[selected.id] || ''
        });
    }

    return (
        <div className="translated-input">

            {selected ? getFormInput(selected) : children}

            <div className="languages-list">
                <a
                    key={0}
                    className={classnames("text-primary", "mr-2", "small", "cursor-pointer", { 'font-weight-bold': !selected })}
                    onClick={(e) => setSelected(null)}>
                    Default
                </a>
                {languages.map((lang) => (
                    <a
                        key={lang.id}
                        className={classnames("text-primary", "mr-2", "small", "cursor-pointer", { 'font-weight-bold': selected?.id == lang.id })}
                        onClick={(e) => setSelected(lang)}>
                        {lang.name}
                    </a>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    languages: state.language.list?.data || [],
});

export default connect(mapStateToProps)(Translated);
